import React from 'react';
import { Stop } from '../../../../../types';
import { ValidatedTextField } from '../../../../shared/inputs/validated-text-field';
import { useDraftLoadStopContext } from '../../../hooks/draft-load-stop-context';
import { editableStopInputProps } from '../../../table-components/stops/editable-stop-table-row';
import { useDraftLoadContext } from '../../../hooks/draft-load-context';
import { stopHasCargo } from '../../../../../constants/constants';
import { InputAdornment } from '@mui/material';
import { getQuantityWeightValidations } from './get-quantity-weight-validations';
import { useWeights } from '../../../../shared/hooks/use-weights';

interface EditableStopQuantityProps {
    stop: Stop;
    isValidated: boolean;
    property: 'quantity' | 'actualQuantity';
}

export const EditableStopQuantity: React.FC<EditableStopQuantityProps> = (props) => {
    const { stop, isValidated, property } = props;
    const { editedLoad } = useDraftLoadContext();
    const { onEditedStopChanged, isCarrier, isComplete } = useDraftLoadStopContext();
    const { convertFromGrams, weightPrecision } = useWeights();

    if (!stopHasCargo(stop)) {
        return null;
    }

    const validations = isValidated
        ? getQuantityWeightValidations(editedLoad, convertFromGrams, weightPrecision)
        : undefined;

    return (
        <ValidatedTextField
            type='number'
            disabled={isCarrier || isComplete}
            value={stop[property] || ''}
            inputProps={{ min: 1, ...editableStopInputProps }}
            fullWidth
            onChange={(e) => {
                onEditedStopChanged({ [property]: Number(e.target.value) || null });
            }}
            InputProps={{
                endAdornment: <InputAdornment position='end'>qty</InputAdornment>,
            }}
            validations={validations}
        />
    )
};
